interface FormDescriptionProps {
  title?: string;
  text?: string;
}

export function FormDescription({ 
  title = "",
  text = ""
}: FormDescriptionProps) {
  return (
    <section className="flex flex-col justify-center w-full max-md:max-w-full" style={{ color: '#374151' }}>
      <h2 className="flex-1 shrink gap-2.5 self-stretch w-full text-xl sm:text-2xl font-semibold basis-0 max-md:max-w-full" style={{ color: '#111827' }}>
        {title}
      </h2>
      <div className="flex-1 shrink gap-2.5 self-stretch mt-2 sm:mt-2.5 w-full text-sm font-normal basis-0 max-md:max-w-full" style={{ color: '#374151' }}>
        <p>
          {text}
        </p>
      </div>
    </section>
  );
}
